import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import ConfirmModal from '../../incase-domain/components/modals/confirmModal/ConfirmModal';
import {endPresentationAction} from '../../store/actions/chalkBoardElements.actions';

interface CloseRoomModalProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
}

function ExitLobbyModal({isOpen, setOpen}: CloseRoomModalProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleExit = (): void => {
        dispatch(endPresentationAction(navigate));
    };

    return (
        <ConfirmModal
            message={t('lobby.closeRoom')}
            icon="solar:logout-3-bold"
            isOpen={isOpen}
            onConfirm={handleExit}
            showCancel
            onCancel={() => setOpen(false)}
        />
    );
}

export default ExitLobbyModal;
